export const BREAKPOINTS = {
  xxxs: 325,
  xxs: 390,
  xs: 480,
  sm: 768,
  md: 992,
  lg: 1024,
  xl: 1200,
  xxl: 1600,
};
